<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader"; 
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import BirimIyılestirmeleri from "./BirimIyılestirmeleri.vue"
import StrIyilestirme from "@/models/StrIyilestirme";import Swal from "sweetalert2";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue"; 
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiFilter.vue";
export default {
  mixins: [Api, Sabit, StrIyilestirme],
  page: {
    title: "İyileştirmeler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit, formcombobox, BirimSecimi, BirimIyılestirmeleri
  },
  data() {
    return {
      title: "İyileştirmeler",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "İyileştirme İşlemleri", 
        },
        {
          text: "İyileştirmeler",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter:{
        Birimid: null,
        Donemid: null,
        Durum: null,
        Turid: null
      },
      DetayId: null,
      BirimSayisi:0,
      TamamlananSayisi:0,
      KaliteRoleKontrol:false, 
    };
  },

  methods: {
    Get() {
      var Filter = "&Desc=Created"

      if(this.Filter.Turid != null){ Filter += "&Turid=" +this.Filter.Turid}
      if(this.Filter.Birimid != null){ Filter += "&Birimid=" +this.Filter.Birimid}
      if(this.Filter.Donemid != null){ Filter += "&Donemid=" +this.Filter.Donemid}
      if(this.Filter.Durum != null){ Filter += "&Durum=" +this.Filter.Durum}

      this.ActionsFilterGet({ Service: "StrIyilestirme", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    BirimGonder(Data){

      Swal.fire({
        title: "Birime Gönder",
        text: "Seçtiğiniz iyileştirme birime gönderilecektir",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Durum = 2
          this.Update("StrIyilestirme", Data,"Birime Gönderildi") 
        }
      });
   
    },
    Tamamla(Data){

      Swal.fire({
        title: "İyileştirmeyi Tamamşa",
        text: "Seçtiğiniz iyileştirme tamamlanacaktır.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Durum = 3
          this.Update("StrIyilestirme", Data,"İyileştirme Tamamlandı") 
        }
      });
   
    },
   getRowClass(Data) {
  const today = new Date().setHours(0, 0, 0, 0);
  const tarih = new Date(Data.Iyilestirmetarih).setHours(0, 0, 0, 0);

  if (Data.Durum == 3) {
    return "bg-success"; // yeşil
  }

  if (tarih < today && Data.Durum != 3) {
    return "bg-danger"; // kırmızı
  }

  if (Data.Kanitlikayitsayisi > 0) {
    return "bg-orange"; // turuncu (özel renk)
  }

  if (Data.Kayitsayisi > 0) {
    return "bg-warning"; // sarı
  }

  if (tarih > today) {
    return "bg-primary"; // mavi
  }

  return "";
},

    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin") || item.includes("StrAdmin") || item.includes("StrIsoKaliteTemsilci")
      );
      if (YetkiSorgu.length != 0) this.KaliteRoleKontrol = true; 
    },

  }, 
  created(){
    
    this.MuneRolesControl();
  }
};
</script>
<style scoped>
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem; 
  box-shadow: none !important;              
}
.bg-orange {
  background-color: #ff6600 !important;  
   
}


</style>
<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
           
      

                  <formcombobox class="col-md-2" 
                  :FormDataType="FormDataType.Turid"
                  :Value="Filter.Turid"
                  :v="$v.Filter.Turid"
                  @input="Filter.Turid = $event"
                />
                  <formcombobox class="col-md-2" 
                  :FormDataType="FormDataType.Donemid"
                  :Value="Filter.Donemid"
                  :v="$v.Filter.Donemid"
                  @input="Filter.Donemid = $event"
                />
                <formcombobox class="col-md-2" 
                  :FormDataType="FormDataType.Durum"
                  :Value="Filter.Durum"
                  :v="$v.Filter.Durum"
                  @input="Filter.Durum = $event"
                />
                <BirimSecimi class="mb-3 col-md-2"
                  :title="FormDataType.Birimids.FieldTitle"
                    :sutun="'0'" 
                    :title_position="'mb-3'"
                    :selected="Filter.Birimid"
                    :labels_lg="'3'"  
                    :v="$v.Filter.Birimid"
                    :multiple="true"
                    :BirimTipId="null"
                    @Secilmis_Idler="Filter.Birimid=$event"
                  />  

                  <div class="col-sm-2 "> 
                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4"  
                    @click="Get()">  <i class="mdi mdi-text-search me-1"></i>Filtreleme</button> 
                </div>

              
                <div class="col-sm-2 ">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2 mt-4" v-b-modal.StrIyilestirme 
                    @click="(DataUpdate = StrIyilestirmeData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i>Yeni Kayıt Ekle</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th style="min-width: 100px;">Kod</th>
                      <th>Dönem</th>
                      <th>Tür</th>
                      <th>Geliştirmeye Açık Yön</th> 
                      <th v-if="0">Amaç</th>
                      <th>Sorumlu Birim / Birimler</th>
                      <th v-if="0">Planlanan İyileştirme</th>
                      <th v-if="0">Bitiş Tarihi</th>
                      <th>Durum</th>
                      <th>Yapılan İyileştirme Tarihi</th> 
                      <th> Planlanan / <br>Tamamlanan Birim </th>
                      <th>Veri Girişi Yapan <br> Kanıt Girişi Yapan</th>
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id"
                      :class="getRowClass(Data)">
                      <th scope="row">{{ Data.Baslamayili }}-{{ Data.Turkodu }}-{{ Data.Kod }}</th> 
                      <td>{{ Data.Donem }}</td>
                      <td>{{ Data.Tur }}</td>
                      <td>{{ Data.Gelistirme }}</td>
                      <td v-if="0">{{ Data.Amac }}</td>
                      <td>{{ Data.Birimler }}</td>
                      <td  v-if="0">{{ Data.Iyilestirme }}</td>
                      <td  v-if="0">{{ Data.Bitistarihi | formatDateTable }}</td> 
                      <td>{{ DurumEnum[Data.Durum] }}</td>
                      <td>{{ Data.Iyilestirmetarih | formatDateTable }}</td> 
                      <td>{{ Data.Birimids ? Data.Birimids.length : 0  }} / {{ Data.Tamamlayanbirimsayisi }}</td>
                      <td>{{ Data.Kayitsayisi  }} / {{ Data.Kanitlikayitsayisi }}</td>
                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          
                          <i v-b-tooltip.hover title="Detay" class="fas fa-eye"  
                           v-b-modal.BirimIyılestirmeleri  @click="DetayId = Data.Id, BirimSayisi = Data.Birimids ? Data.Birimids.length : 0, TamamlananSayisi = Data.Tamamlayanbirimsayisi" v-if="Data.Durum != 1"></i>
                          <i v-b-tooltip.hover title="Birime Gönder" class="fas fa-paper-plane"  @click="BirimGonder(Data)" v-if="Data.Durum == 1"></i>
                          <i v-b-tooltip.hover title="Düzenle" class="fas fa-pencil-alt" v-b-modal.StrIyilestirme @click="(DataUpdate = Data), (AddEdit = 'Edit')" v-if="Data.Durum != 3"></i>
                          <i v-b-tooltip.hover title="Sil" class="fas fa-trash-alt" @click="Delete('StrIyilestirme', Data.Id)" v-if="Data.Durum != 3 && KaliteRoleKontrol"></i>
                          <i v-b-tooltip.hover title="Tamamla" class="fas fa-check"  @click="Tamamla(Data)" v-if="Data.Durum == 2"></i>
                        </div>
                      </td>
                    </tr> 
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get"   />
      <BirimIyılestirmeleri :Id="DetayId"   :BirimSayisi="BirimSayisi" :TamamlananSayisi="TamamlananSayisi"  />

      
    </Layout>
  </Loader>
</template>
